import { render, staticRenderFns } from "./SubPanelTitle.vue?vue&type=template&id=7bc9fc37&scoped=true"
var script = {}
import style0 from "./SubPanelTitle.vue?vue&type=style&index=0&id=7bc9fc37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc9fc37",
  null
  
)

export default component.exports